import { FC } from "react";

import { Box, Button } from "@chakra-ui/react";
import { IoCloseCircle } from "react-icons/io5";
import { theme } from "@ovou-inc/ovou-ui";
import { DrawerComponent } from "../../components/Drawer";
import { Text } from "../../components/Typography";
import { useFeatureCosts } from "api/payments/useFeatureCosts";

export interface AboutCreditsDrawerProps {
  isOpen: boolean;
  onClose: () => unknown;
  showOverlay?: boolean;
}

export const AboutCreditsDrawer: FC<AboutCreditsDrawerProps> = ({
  isOpen,
  onClose,
  showOverlay = false,
}) => {
  const { data: featureCosts } = useFeatureCosts();
  const enrichmentCost =
    featureCosts?.find(item => item.id == "CONTACT_ENRICHMENT")?.cost || null;
  return (
    <DrawerComponent
      isOpen={isOpen}
      onClose={onClose}
      showOverlay={showOverlay}
    >
      <Box padding="24px">
        <Box display="flex" alignItems="flex-end" margin="24px 0 12px">
          <Text
            fontSize="24px"
            fontWeight="800"
            lineHeight="125%"
            color={theme.palette.brand.primary.black}
          >
            About OVOU Credits
          </Text>
        </Box>
        <Box
          onClick={onClose}
          position="absolute"
          top="24px"
          right="24px"
          cursor="pointer"
        >
          <IoCloseCircle size={32} color="rgba(0, 0, 0, 0.30)" />
        </Box>
        <Text
          color={theme.palette.ui.greys.grey1}
          fontSize="16px"
          fontStyle="normal"
          fontWeight="400"
          lineHeight="150%"
        >
          OVOU Credits are used for contact enrichment. Turning a basic contact
          into a rich, professional profile using AI.
          {enrichmentCost ? (
            <Box>
              <ul style={{ listStyle: "inside", paddingLeft: "10px" }}>
                <li>{enrichmentCost} credit = 1 enrichment</li>
                <li>
                  You use {enrichmentCost} credit each time you enrich a contact
                </li>
                <li>Credits never expire and can be used anytime</li>
              </ul>
            </Box>
          ) : null}
          <br />
          You'll be notified when you're running low. Need more? You can easily
          top up with a credit pack.
        </Text>

        <Box mt="60px">
          <Button width="100%" onClick={onClose}>
            Got It
          </Button>
        </Box>
      </Box>
    </DrawerComponent>
  );
};
